// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"79f36eb2","680":"a440d6b6","755":"a2e18ca3","802":"5ee450f3","965":"d18a9a88"}[chunkId] + ".chunk.css";
};